import className from 'classnames';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import ReactDOM from 'react-dom';

import AccordiItemBody from './AccordiItemBody';
import AccordiItemTitle from './AccordiItemTitle';
import { getStyles } from '../../../styles/dynamicStyles';

export default class AccordiItem extends Component {

  constructor(props) {
    super(props);
    this.state = {
      expanded: props.expanded,
      maxHeight: props.expanded ? 'none' : 0,
      overflow: props.expanded ? 'visible' : 'hidden'
    };
  }

  componentDidMount() {
    this.setMaxHeight();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.expanded !== this.state.expanded) {
      this.setMaxHeight();
    }
  }

  allowOverflow() {
    this.setState({
      maxHeight: 'none',
      overflow: 'visible'
    });
  }

  updateState = (node) => {
    // if (!this.state.expanded) {
    //   this.setState({
    //     maxHeight: node.scrollHeight + 'px'
    //   });
    // }

    // setTimeout(() => this.setState({
    //   maxHeight: this.state.expanded ? node.scrollHeight + 'px' : 0,
    //   overflow: 'hidden'
    // }), 0);

    this.setState({
      maxHeight: this.state.expanded ? node.scrollHeight + 'px' : 0,
      overflow: 'hidden'
    })
  }

  setMaxHeight = () => {
    var bodyNode = ReactDOM.findDOMNode(this.refs.body);
    var images = bodyNode.querySelectorAll('img');

    if (images.length > 0) {
      this.preloadImages(bodyNode, images);
      return;
    }

    this.updateState(bodyNode);
  }

  // Wait for images to load before calculating maxHeight
  preloadImages = (node, images) => {
    var imagesLoaded = 0;

    var imgLoaded = () => {
      imagesLoaded++;

      if (imagesLoaded === images.length) {
        this.updateState(node);
      }
    };

    for (let i = 0; i < images.length; i += 1) {
      const img = new Image();
      img.src = images[i].src;
      img.onload = img.onerror = imgLoaded;
    }
  }

  getProps = () => {
    var props = {
      className: className([
        'c-accorditabs__tab',
        this.props.className,
        { 'state-active': this.state.expanded },
        { [this.props.expandedClassName]: this.state.expanded }
      ]),
      role: 'tabpanel',
      style: this.props.style
    };

    if (this.state.expanded) {
      props['aria-expanded'] = true;
    } else {
      props['aria-expanded'] = false;
    }

    return props;
  }

  onClick = () => {
    this.setState({expanded: !this.state.expanded})
  }

  render() {
    return (
      <section {...this.getProps() } style={getStyles('c-accorditabs__tab')} ref="item">
        <AccordiItemTitle
          className={this.props.titleClassName}
          title={this.props.title}
          onClick={this.onClick}
          titleColor={this.props.titleColor}
          id={this.props.id} />
        <AccordiItemBody maxHeight={this.state.maxHeight}
          className={this.props.bodyClassName}
          overflow={this.state.overflow}
          ref="body"
          tab={this.props.tab}
          id={this.props.id}
        >
          {this.props.children}
        </AccordiItemBody>
      </section>
    );
  }
}

AccordiItem.propTypes = {
  id: PropTypes.string.isRequired,
  bodyClassName: PropTypes.string,
  className: PropTypes.string,
  expanded: PropTypes.bool,
  expandedClassName: PropTypes.string,
  style: PropTypes.object,
  titleClassName: PropTypes.string
};

AccordiItem.defaultProps = {
  expanded: false
}



// WEBPACK FOOTER //
// ./webapp/components/elements/AccordiTab/AccordiItem.js